import { Utilities, type User } from 'core/domains';

export const initialState: User = {
  buyIntention: {
    items: [],
    message: '',
    status: Utilities.STATUS.IDLE,
  },
  data: {
    brand: '',
    cycle: {
      currentCycle: 0,
      daysLeft: 0,
      daysTotal: 0,
      finalDate: '',
      initialDate: '',
      nextCycle: 0,
    },
    fullAddress: '',
    isBlocked: false,
    isCeased: false,
    isMultiBrand: false,
    name: '',
    region: '',
    resellerId: '',
    shippingModel: {} as User['data']['shippingModel'],
    supervisor: {} as User['data']['supervisor'],
    isExtendedCapitation: false,
    isWithdrawalCenter: false,
    avaliableCycles: {} as User['data']['avaliableCycles'],
    isResaleIntention: false,
    isAutoStartEnabled: false,
  },
  credit: {
    data: {
      available: '',
      availableNum: 0,
      cashback: 0,
      notOverdue: 0,
      overdue: 0,
      toBill: 0,
      tolerancePercentage: 0,
      total: 0,
    },
    message: '',
    status: Utilities.STATUS.IDLE,
    updatedAt: 0,
  },
  incentiveCampaigns: {
    data: {
      success: true,
      data: [
        {
          id: '',
          title: '',
          description: '',
          contentId: '',
          status: '',
        },
      ],
    },
    message: '',
    status: Utilities.STATUS.IDLE,
  },
  itemAddCartError: [],
  message: '',
  shippingModelSearch: '',
  status: Utilities.STATUS.IDLE,
  updatedAt: 0,
};
